<template>
  


    <div class="block block-rounded push">
      <!--
        <div class="block-header">
          
          <h2 class="block-title">{{ sectionTitle[actualLanguage] }}</h2>
          
        </div>
        -->
        <div class="block-content">
          <div class=" form-group row">
            <div class="col-xs-12 col-sm-12 align-center push">
                  <button type="button" @click="startMeasurement"  class="btn  btn-success align-center" ><i class="fa fa-bars fa-1x push-5-r "></i> {{ buttonLabelStartAcquisition[actualLanguage] }}</button>
            </div>

            <div v-show="flagDisplayLiveData" class="col-xs-12 col-sm-12 push">
              <div v-if="flagDisplayMessageHowToUse" class="col-xs-12 col-sm-12">
                <h2 class="block-title align-center">{{ messageHowToUse[actualLanguage] }}</h2>
              </div>


              <div v-for="(channel,index) in channelList">

                  <div class="col-xs-12 col-sm-6">
                    <div class="block block-bordered">
                      <div class="block-content">
                        <div class="row">
                          <div class="col-xs-12 align-center">
                            <span class="h3 text-black-op" style="font-weight: bold;">{{ channel.channelName }}</span>
                          </div>

                          <div class="col-xs-12 align-center">
                          <a class="block block-link-hover block-rounded">
                              <div class="block-content block-content-full clearfix" v-bind:style="{backgroundColor:channel.color}">
                                
                                <div class="col-xs-12">
                                  <span class="h3 text-white-op" style="font-weight: bold;">{{tileTotalPower[actualLanguage]}} : {{ channel.lastTotalPower }} W</span>
                                </div>

                                <div v-for="(port,index2) in channel.devicePorts" class="col-xs-12">
                                  <span class="h4 text-white-op" style="font-weight: bold;">{{tileSensor[actualLanguage]}} {{index2+1}}: {{ channel.lastPower[index2]}} W / {{channel.lastCurrent[index2]}} A</span>
                                </div>             

                              </div>
                          </a>
                          </div>

                          <div class="col-xs-12">
                              <div class="col-xs-9">
                                <h4 class="h5 text-center">{{labelDisplayGraph[actualLanguage]}}</h4>
                              </div>
                              <div class="col-xs-3">
                                <label class="css-input switch switch-success">
                                    <input type="checkbox" checked v-model="channel.flagDisplayGraph"><span></span>
                                </label>
                              </div>
                          </div>

                          <div v-if="channel.flagDisplayGraph" class="col-xs-12">
                              <div class="col-xs-9">
                                <h5 class="h5 text-center">{{labelDisplayCurrent[actualLanguage]}}</h5>
                              </div>
                              <div class="col-xs-3">
                                <label class="css-input switch switch-success">
                                    <input type="checkbox" @change="updateGraphData(index)" checked v-model="channel.flagDisplayCurrent"><span></span>
                                </label>
                              </div>
                          </div>

                          <div v-if="channel.flagDisplayGraph" class="col-xs-12">
                              <div id="chart">
                                <apexchart type="area" height="300" :options="chartOptions" :series="chartDataSeries[index]"></apexchart>
                              </div>                
                          </div>

                        </div>

                    </div>
                  </div>
                </div>


              </div>

              <div class="col-xs-12 col-sm-12 align-center push">
                    <button type="button" @click="stopMeasurement" class="btn  btn-success align-center" ><i class="fa fa-close fa-1x push-5-r "></i> {{ buttonClose[actualLanguage] }}</button>
              </div>

            </div>

          </div>
        </div>

    </div>


</template>

<script>

/*
                                      <option value="#46c37b">Vert std/Green std</option>
                                      <option value="#0000ff">Bleu/Blue</option>
                                      <option value="#00ff00">Vert/Green</option>
                                      <option value="#e1e100">Jaune/Yellow</option>
                                      <option value="#ff0000">Rouge/Red</option>
*/

import _ from 'underscore'
import {mapState, mapGetters,mapActions} from 'vuex'

import VueApexCharts from 'vue-apexcharts'
export default {
  props: ['tableData'],
  data() {
    return {
      displayDataTable : false,

      flagCloudLiveIsActivating : false,
      flagCloudLiveIsActivated : false,
      dataPoolingIsActive : false,
      dataPoolingCounter : 0,
      dataIsLoading : false,

      flagDisplayLiveData : false,
      flagDisplayMessageHowToUse : false,


      polling : null,
      deviceToPoolList : [],
      deviceData : {},
      deviceDataModel : {'dataTimestampEpoch':[],
                        'dataTimestamp':[],
                         'I_RMS':{'P01':[],'P02':[],'P03':[],'P04':[],'P05':[],'P06':[]},
                         'Power':{'P01':[],'P02':[],'P03':[],'P04':[],'P05':[],'P06':[]}},

      channelList : [],
      channelDataModel : {'channelName':'',
                          'lastTotalPower':0,
                          'lastPower':[],
                          'color':"#46c37b",
                          'linkedDevice':'',
                          'devicePorts':[],
                          'lastCurrent':[],
                          'dataTimestampEpoch':[],
                          'dataTimestamp':[],
                          'dataTotalPower':[],
                          'portLabel':[],
                          'dataPowerPerPort':[],
                          'dataCurrentPerPort':[],
                          'flagDisplayGraph':false,
                          'flagDisplayCurrent':false,
                          'liveMeasurementConfiguration':{}
                          },

      dataTimestamp : [],
      dataRead : [],
      
      actualLanguage : "FR",
      sectionTitle: {FR: 'Mesure de puissance temps réel', EN: 'Real time power measurement'},
      buttonLabelStartAcquisition: {FR: 'Lancer la mesure', EN: 'Start measurement'},
      tileTotalPower: {FR: 'Puissance totale', EN: 'Total power'},
      tileSensor: {FR: 'Capteur ', EN: 'Sensor '},
      buttonClose: {FR: 'Fermer', EN: 'Close'},

      labelDisplayGraph: {FR: 'Afficher graphique ', EN: 'Display graph '},
      labelDisplayCurrent : {FR: 'Afficher le courant ', EN: 'Display current '},
      labelGraphTotalPower: {FR: 'Puissance totale ', EN: 'Total power'},
      labelGraphTotalPower: {FR: 'Puissance ', EN: 'Power'},
      labelGraphCurrent :{FR: 'Courant ', EN: 'Current '},
      messageHowToUse :{FR: "Aucun appareil mesuré configuré pour la mesure temps réel. Vous devez sélectionner cette option dans la configuration de votre appareil mesuré pour activer son visionnement.",
                         EN: 'No measured device configured for real-time measurement. You must select this option in the configuration of your measured device to activate its viewing.'},

      chartDataSeries : [],
      chartOptions: {
        chart: {
          type: 'area',
          stacked: false,
          height: 300,
          zoom: {
            type: 'x',
            enabled: true,
            autoScaleYaxis: true
          },
          toolbar: {
            autoSelected: 'zoom'
          }
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0,
        },
        title: {
          text: '',
          align: 'left'
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            inverseColors: false,
            opacityFrom: 0.5,
            opacityTo: 0,
            stops: [0, 70, 100]
          },
        },
        xaxis: {
            //type: 'datetime'
          }
      },



    }
  },
  computed: {
    ...mapState('sessionStore', ['actualBundle']),
  },
  methods: {
 
    startMeasurement(){
      //console.log("Start measurement")
      //console.log(this.actualBundle.channels)

      this.channelList = []
      var deviceID = ''
      for (let j = 0; j < this.actualBundle.channels.length;j++){
        if (this.actualBundle.channels[j].ChannelData.liveMeasurementConfiguration.enabled){
          deviceID = this.actualBundle.channels[j].ChannelData.linkedDevicePorts.deviceId
          this.channelList.push(JSON.parse(JSON.stringify(this.channelDataModel)))
          this.channelList[this.channelList.length-1].channelName = this.actualBundle.channels[j].ReferenceName
          this.channelList[this.channelList.length-1].liveMeasurementConfiguration = this.actualBundle.channels[j].ChannelData.liveMeasurementConfiguration
          this.channelList[this.channelList.length-1].devicePorts= this.actualBundle.channels[j].ChannelData.linkedDevicePorts.ports
          this.channelList[this.channelList.length-1].linkedDevice=this.actualBundle.channels[j].ChannelData.linkedDevicePorts.deviceId

          //console.log(this.channelList[this.channelList.length-1])

          for (let k = 0; k < this.actualBundle.channels[j].ChannelData.linkedDevicePorts.ports.length;k++){
            this.channelList[this.channelList.length-1].lastPower.push(0)
            this.channelList[this.channelList.length-1].lastCurrent.push(0)
            this.channelList[this.channelList.length-1].dataPowerPerPort.push([])
            this.channelList[this.channelList.length-1].dataCurrentPerPort.push([])
            this.channelList[this.channelList.length-1].portLabel.push(this.tileSensor[this.actualLanguage] + ": " + (k+1).toString())

          }

          this.chartDataSeries.push({})

          if(this.deviceToPoolList.includes(this.actualBundle.channels[j].ChannelData.linkedDevicePorts.deviceId)==false){
            //Lancer le live sur le module
            this.deviceToPoolList.push(deviceID)
            this.deviceData[deviceID] = JSON.parse(JSON.stringify(this.deviceDataModel))
            this.startModuleCloudLive(deviceID)
          }
        }
      }

      if(this.channelList.length==0){
        this.flagDisplayMessageHowToUse = true
      }else{
        this.flagDisplayMessageHowToUse = false
      }

      clearInterval()
      this.dataPoolingCounter = 0
      this.pollData()
      
      this.$nextTick(() => {
        this.flagDisplayLiveData = true
      });

    },

    stopMeasurement(){
      this.flagDisplayLiveData = false
      clearInterval()
    },

    startModuleCloudLive(deviceId){
      this.flagCloudLiveIsActivating = true
      var requestData = { 'postAction':'EnableDeviceLiveCloudReadings',
                        'deviceId': deviceId,
                    }
      this.$store.dispatch('sessionStore/postDevice', requestData)
          .then((response) => {
          //response.data.Code='OK'
          this.flagCloudLiveIsActivating = false
          if(response.data.Code=='OK'){
              this.flagCloudLiveIsActivated = true
              }
              else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
          })  
    },

    pollData () {
      this.polling = setInterval(() => {
        this.readModuleLiveData()
      }, 3000)
    },


    readModuleLiveData(){
      this.dataPoolingCounter += 1
      if(this.dataPoolingCounter>=30){
          clearInterval(this.polling)
          this.dataPoolingIsActive=false
      }


      var deviceID = ''
      var startTimestamp_epoch = moment().unix() - 20
      this.dataIsLoading = true
      var sensorCount = 0
      var lastTotalPower = 0

      for (let j = 0; j < this.deviceToPoolList.length;j++){
        deviceID = this.deviceToPoolList[j]
        if(this.deviceData[deviceID].dataTimestampEpoch.length > 0){
            startTimestamp_epoch = this.deviceData[deviceID].dataTimestampEpoch[this.deviceData[deviceID].dataTimestampEpoch.length-1]
        }
        var requestData = { 'postAction':'GetDeviceLiveCloudReadings',
                            'bundleId': this.actualBundle.bundleId,
                            'deviceId':deviceID,
                            'startTimestamp':startTimestamp_epoch,
                            }

        this.$store.dispatch('sessionStore/postDevice', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){

                //console.log(response.data)

                for(let n=0;n < response.data.DataTimestamp.length;n++){
                        this.deviceData[deviceID].dataTimestampEpoch.push(response.data.DataTimestamp[n])
                        this.deviceData[deviceID].dataTimestamp.push(moment(response.data.DataTimestamp[n]*1000).format('HH:mm:ss'))

                        this.deviceData[deviceID].I_RMS.P01.push(response.data.LiveData[n].currentRMS[0])
                        this.deviceData[deviceID].I_RMS.P02.push(response.data.LiveData[n].currentRMS[1])
                        this.deviceData[deviceID].I_RMS.P03.push(response.data.LiveData[n].currentRMS[2])
                        this.deviceData[deviceID].I_RMS.P04.push(response.data.LiveData[n].currentRMS[3])
                        this.deviceData[deviceID].I_RMS.P05.push(response.data.LiveData[n].currentRMS[4])
                        this.deviceData[deviceID].I_RMS.P06.push(response.data.LiveData[n].currentRMS[5])

                        this.deviceData[deviceID].Power.P01.push(response.data.LiveData[n].power[0])
                        this.deviceData[deviceID].Power.P02.push(response.data.LiveData[n].power[1])
                        this.deviceData[deviceID].Power.P03.push(response.data.LiveData[n].power[2])
                        this.deviceData[deviceID].Power.P04.push(response.data.LiveData[n].power[3])
                        this.deviceData[deviceID].Power.P05.push(response.data.LiveData[n].power[4])
                        this.deviceData[deviceID].Power.P06.push(response.data.LiveData[n].power[5])

                        //Update values of each channel
                        for(let k=0;k < this.channelList.length;k++){
                          if (this.channelList[k].linkedDevice==deviceID){
                            this.channelList[k].dataTimestampEpoch.push(response.data.DataTimestamp[n])
                            this.channelList[k].dataTimestamp.push(moment(response.data.DataTimestamp[n]*1000).format('HH:mm:ss'))

                            sensorCount = 0
                            lastTotalPower = 0
                            if(this.channelList[k].devicePorts.indexOf("1")>-1){
                              this.channelList[k].lastCurrent[sensorCount]=response.data.LiveData[n].currentRMS[0].toFixed(2)
                              this.channelList[k].lastPower[sensorCount]=response.data.LiveData[n].power[0].toFixed(1)
                              lastTotalPower += response.data.LiveData[n].power[0]
                              this.channelList[k].dataPowerPerPort[sensorCount].push(response.data.LiveData[n].power[0].toFixed(1))
                              this.channelList[k].dataCurrentPerPort[sensorCount].push(response.data.LiveData[n].currentRMS[0].toFixed(2))                             
                              sensorCount +=1
                            }

                            if(this.channelList[k].devicePorts.indexOf("2")>-1){
                              this.channelList[k].lastCurrent[sensorCount]=response.data.LiveData[n].currentRMS[1].toFixed(2)
                              this.channelList[k].lastPower[sensorCount]=response.data.LiveData[n].power[1].toFixed(1)
                              lastTotalPower += response.data.LiveData[n].power[1]
                              this.channelList[k].dataPowerPerPort[sensorCount].push(response.data.LiveData[n].power[1].toFixed(1))
                              this.channelList[k].dataCurrentPerPort[sensorCount].push(response.data.LiveData[n].currentRMS[1].toFixed(2))
                              sensorCount +=1
                            }

                            if(this.channelList[k].devicePorts.indexOf("3")>-1){
                              this.channelList[k].lastCurrent[sensorCount]=response.data.LiveData[n].currentRMS[2].toFixed(2)
                              this.channelList[k].lastPower[sensorCount]=response.data.LiveData[n].power[2].toFixed(1)
                              lastTotalPower += response.data.LiveData[n].power[2]
                              this.channelList[k].dataPowerPerPort[sensorCount].push(response.data.LiveData[n].power[2].toFixed(1))
                              this.channelList[k].dataCurrentPerPort[sensorCount].push(response.data.LiveData[n].currentRMS[2].toFixed(2))
                              sensorCount +=1
                            }

                            if(this.channelList[k].devicePorts.indexOf("4")>-1){
                              this.channelList[k].lastCurrent[sensorCount]=response.data.LiveData[n].currentRMS[3].toFixed(2)
                              this.channelList[k].lastPower[sensorCount]=response.data.LiveData[n].power[3].toFixed(1)
                              lastTotalPower += response.data.LiveData[n].power[3]
                              this.channelList[k].dataPowerPerPort[sensorCount].push(response.data.LiveData[n].power[3].toFixed(1))
                              this.channelList[k].dataCurrentPerPort[sensorCount].push(response.data.LiveData[n].currentRMS[3].toFixed(2))
                              sensorCount +=1
                            }

                            if(this.channelList[k].devicePorts.indexOf("5")>-1){
                              this.channelList[k].lastCurrent[sensorCount]=response.data.LiveData[n].currentRMS[4].toFixed(2)
                              this.channelList[k].lastPower[sensorCount]=response.data.LiveData[n].power[4].toFixed(1)
                              lastTotalPower += response.data.LiveData[n].power[4]
                              this.channelList[k].dataPowerPerPort[sensorCount].push(response.data.LiveData[n].power[4].toFixed(1))
                              this.channelList[k].dataCurrentPerPort[sensorCount].push(response.data.LiveData[n].currentRMS[4].toFixed(2))
                              sensorCount +=1
                            }

                            if(this.channelList[k].devicePorts.indexOf("6")>-1){
                              this.channelList[k].lastCurrent[sensorCount]=response.data.LiveData[n].currentRMS[5].toFixed(2)
                              this.channelList[k].lastPower[sensorCount]=response.data.LiveData[n].power[5].toFixed(1)
                              lastTotalPower += response.data.LiveData[n].power[5]
                              this.channelList[k].dataPowerPerPort[sensorCount].push(response.data.LiveData[n].power[5].toFixed(1))
                              this.channelList[k].dataCurrentPerPort[sensorCount].push(response.data.LiveData[n].currentRMS[5].toFixed(2))                              
                              sensorCount +=1
                            }
                            this.channelList[k].lastTotalPower=lastTotalPower.toFixed(1)
                            this.channelList[k].dataTotalPower.push(lastTotalPower.toFixed(1))

                            if (lastTotalPower < this.channelList[k].liveMeasurementConfiguration.powerWarningLevel){
                              //Green
                              this.channelList[k].color = "#46c37b"
                            }else{
                              if(lastTotalPower > this.channelList[k].liveMeasurementConfiguration.powerLimitLevel){
                                //Red
                                this.channelList[k].color = "#ff0000"
                              }else{
                                //Yellow
                                this.channelList[k].color = "#e1e100"
                              }

                            }

                            this.updateGraphData(k)
                          }
                        }

                    }

                    
                }
                else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
                this.dataIsLoading = false
            })
      }

    },


    updateGraphData(channelIndex){
      this.chartDataSeries[channelIndex] = []
      var NewGraphDataTempo = []
      var portDataTempo = []
      var actualValue = 0.0

      NewGraphDataTempo = []


      if (this.channelList[channelIndex].flagDisplayCurrent){
        //Affichage de courant
          for(var j = 0; j < this.channelList[channelIndex].dataPowerPerPort.length;j++){
            NewGraphDataTempo = []
            portDataTempo = this.channelList[channelIndex].dataCurrentPerPort[j]
            for(var i = 0; i < portDataTempo.length;i++){
                actualValue = portDataTempo[i]
                NewGraphDataTempo.push([this.channelList[channelIndex].dataTimestampEpoch[i]-this.channelList[channelIndex].dataTimestampEpoch[0],actualValue])
              }
            this.chartDataSeries[channelIndex].push({name:this.labelGraphCurrent[this.actualLanguage]+this.tileSensor[this.actualLanguage]+(j+1).toString(),data:NewGraphDataTempo})
          }

      }else{
          //Affichage de puissance
          portDataTempo = this.channelList[channelIndex].dataTotalPower
          for(var i = 0; i < portDataTempo.length;i++){
              actualValue = portDataTempo[i]
              NewGraphDataTempo.push([this.channelList[channelIndex].dataTimestampEpoch[i]-this.channelList[channelIndex].dataTimestampEpoch[0],actualValue])
            }
          this.chartDataSeries[channelIndex].push({name:this.labelGraphTotalPower[this.actualLanguage],data:NewGraphDataTempo})

          for(var j = 0; j < this.channelList[channelIndex].dataPowerPerPort.length;j++){
            NewGraphDataTempo = []
            portDataTempo = this.channelList[channelIndex].dataPowerPerPort[j]
            for(var i = 0; i < portDataTempo.length;i++){
                actualValue = portDataTempo[i]
                NewGraphDataTempo.push([this.channelList[channelIndex].dataTimestampEpoch[i]-this.channelList[channelIndex].dataTimestampEpoch[0],actualValue])
              }
            this.chartDataSeries[channelIndex].push({name:this.tileSensor[this.actualLanguage]+(j+1).toString(),data:NewGraphDataTempo})
          }


      }
    }


  },
  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
    clearInterval()
  }
}
</script>


<style scoped lang="css">

  .block-title, .h3 {
    font-size: 18px; /* Taille de police par défaut */
  }

  .h4 {
    font-size: 16px; /* Taille de police par défaut */
  }
  .h5 {
    font-size: 16px; /* Taille de police par défaut */
  }

  /* Media Query pour les écrans de moins de 600px de large */
  @media (max-width: 600px) {

      .block-title, .h3 {
          font-size: 16px; /* Taille de police réduite pour les petits écrans */
      }
      .h4 {
          font-size: 12px; /* Taille de police réduite pour les petits écrans */
      }
      .h5 {
          font-size: 12px; /* Taille de police réduite pour les petits écrans */
      }
  }

</style>



// WEBPACK FOOTER //
// PowerLiveMonitor.vue?6ef164b7